import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationCancel, NavigationEnd } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class AppComponent implements OnInit {
    location: any;
    routerSubscription: any;

    constructor(private router: Router) {
    }

    ngOnInit(){
        this.recallJsFuntions();
    }

    recallJsFuntions() {
        this.router.events
        .subscribe((event) => {
            if ( event instanceof NavigationStart ) {
                //$('.preloader').fadeIn('slow'); - trying to avoid using jQuery directly
            }
        });
        this.routerSubscription = this.router.events
        .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
        .subscribe(event => {
            //$.getScript('../assets/js/main.js'); - trying to avoid using jQuery directly
            //$('.preloader').fadeOut('slow'); - trying to avoid using jQuery directly
            this.location = this.router.url;
            if (!(event instanceof NavigationEnd)) {
                return;
            }
            // Always start every routed page at the top.
            // requestAnimationFrame waits until Angular has rendered the new view.
            if (typeof window !== 'undefined') {
                window.requestAnimationFrame(() => {
                    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
                });
            }
        });
    }
}
